import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { ISidebar, SidebarService } from '../sidebar/sidebar.service';
import { GlobalService } from '../../services/global.service';
// import { WholesalerService } from '../../services/wholesaler.service'
import { FormBuilder, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { RequestServices } from '../../services/request.services';
@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss']
})
export class TopnavComponent implements OnInit {
  @ViewChild('addWholesaler') addWholesalerModal: TemplateRef<any>
  @ViewChild('instructions') instructionsModal: TemplateRef<any>
  @ViewChild('editProfileModal') editProfileModal!: TemplateRef<any>;
  bsModalRef!: BsModalRef;

  wholesalerModalRef: BsModalRef;
  addWholesalerForm: FormGroup;
  instructionsModalRef: BsModalRef;
  showPassword = false;
  showConfirmPassword = false
  proList: []
  latitude: number;
  longitude: number;
  displayName = localStorage.getItem('UserName');
  sidebar: ISidebar;
  currentLanguage: string;
  isSingleLang;
  isFullScreen = false;
  isDarkModeActive = false;
  searchKey = '';
  subscription: Subscription;
  fileUpdModalRef: BsModalRef;
  fileToUpload: any;
  modalRef: BsModalRef;
  checkroute = false;
  checkdashboard = false;
  wholesalerName = "";
  cTime: any = 'April 18, 2018 9:45am';
  public modalConfig: any = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    class: 'modal-md',
  };
  proObj = undefined;
  licenseFile = undefined;
  fileMsg: string = '';
  isLicenseValid: boolean = true;
  fileText: string = "Select License File";
  _top_nav_bar = {
    licenseValidityStr: '',
    _btn_disable: false,
  }
  topNavVar = {
    wholesalers: [],
    proId: undefined,
    proName: null,
    proPhoneNumer: null
  }

  editProfileForm!: FormGroup;
  currentLocationLatLng: any;
  consumerVar = {
    rows: [],
    currentPage: 1,
    pageCount: 0,
    states: [],
    countries: [],
    pros: [],
    apiResponse: false,
  }

  constructor(
    public global: GlobalService,
    private sidebarService: SidebarService,
    private modalService: BsModalService,
    private formBuilder: UntypedFormBuilder,
    private service: RequestServices,
    private fb: FormBuilder,

    public router: Router,

  ) {
    this.isDarkModeActive = this.getColor().indexOf('dark') > -1 ? true : false;
  }

  ngOnInit(): void {
    // this.getWholesaler();
    this.initWholesalerForm();
    this.initForm();
    this.getProByID();
    this.getCountries();
    // this.global.name = this.global.getProObj().proName
    this.subscription = this.sidebarService.getSidebar().subscribe(
      res => {
        this.sidebar = res;
      },
      err => {
        console.error(`An error occurred: ${err.message}`);
      }
    );
    navigator

    this.proObj = this.global.getProObj();
    console.log("proObj in top", this.proObj.wholesalerName);
    this.wholesalerName = this.proObj.wholesalerName;
  }

  clearDistance() {
    this.addWholesalerForm.get('name')?.reset();
    this.proList = [];
  }


  initForm() {
    this.editProfileForm = this.fb.group({
      id: [0],
      firstName: [null, [Validators.required, Validators.pattern("^[a-zA-Z.&()/,'0-9\\s-]+$")]],
      lastName: [null, [Validators.required]],
      email: [
        null,
        [
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
        ]
      ],
      passwordHash: ['', [
        Validators.minLength(8),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%#*?&])[A-Za-z\\d@$!%#*?&]{8,}$')
      ]],

      confirmPassword: ['',[Validators.required]],
      phoneNumber: [null, [Validators.required]],
      countryId: [null],
      stateId: [null, [Validators.required]],
      country: [null, [Validators.required]],
      cityName: [null, [Validators.required, Validators.pattern("^[a-zA-Z\\s.'-]+$")]],
      zipcode: [null, [Validators.required, Validators.pattern("^[0-9 A-Za-z]+$")]],
      address1: [null, [Validators.required, Validators.pattern("^[a-zA-Z0-9&()',./_\\s-]+$")]],
      address2: [''],
      defaultProId: [null],
      createdBy: [null],
      isSelfCreated: [false],
      stepNo: [null],
      fCMToken: [''],
      gPSLocation: ['']


    }, { validator: this.passwordMatchValidator });

  }


  ngAfterViewInit() {
    this.checkWholesaler();
  }

  patchProfileForm(consumerData: any) {
    // Reset the form first
    this.editProfileForm.reset();
    let countryId = consumerData.countryId || null;
    let stateId = consumerData.stateId || null;
    if (countryId && !consumerData.country) {
      const country = this.consumerVar.countries.find(c => c.id === countryId);
      if (country) {
        this.consumerVar.states = country.states || [];
      }
    }

    if (!countryId && consumerData.countryCode && this.consumerVar.countries.length > 0) {
      const country = this.consumerVar.countries.find(c => c.code === consumerData.countryCode);
      if (country) {
        countryId = country.id;
        this.consumerVar.states = country.states || [];
      }
    }

    // If we have stateId but stateCode is null, we still need to handle it
    if (stateId && this.consumerVar.states.length > 0) {
      // Check if the state exists in our states list
      const stateExists = this.consumerVar.states.find(s => s.id === stateId);
      if (!stateExists) {
        // State might not be loaded yet, try to load it from country
        const country = this.consumerVar.countries.find(c => c.id === countryId);
        if (country && country.states) {
          this.consumerVar.states = country.states;
        }
      }
    }

    const createdBy = consumerData.createdBy ? Number(consumerData.createdBy) : 0;
    const stepNo = consumerData.stepNo ? Number(consumerData.stepNo) : 0;
    this.editProfileForm.patchValue({
      id: consumerData.id || 0,
      firstName: consumerData.firstName || consumerData.firstname || consumerData.name?.split(' ')[0] || '',
      lastName: consumerData.lastName || consumerData.lastname || consumerData.name?.split(' ').slice(1).join(' ') || '',
      email: consumerData.email || '',
      phoneNumber: consumerData.phoneNumber || consumerData.phone || '',
      address1: consumerData.address1 || consumerData.address?.address1 || '',
      address2: consumerData.address2 || consumerData.address?.address2 || '',
      cityName: consumerData.cityName || consumerData.city || '',
      zipcode: consumerData.zipcode || consumerData.zipCode || '',
      country: countryId,
      stateId: stateId,
      defaultProId: consumerData.defaultProId || '',
      createdBy: createdBy,
      isSelfCreated: consumerData.isSelfCreated || false,
      stepNo: stepNo,
      fCMToken: consumerData.fCMToken || consumerData.fcmToken || '',
      gPSLocation: consumerData.gPSLocation || consumerData.gpsLocation || '',
      passwordHash: consumerData.passwordHash || ''
    });

    // Also update the separate countryId control if it exists
    if (countryId && this.editProfileForm.get('countryId')) {
      this.editProfileForm.controls['countryId'].setValue(countryId);
    }
  }


  openEditprofile() {
    // Get the current user ID from proObj
    const consumerId = this.proObj?.id || this.global.getProObj().id;

    if (!consumerId) {
      this.global.showNotification('Error', '', 'User ID not found');
      return;
    }

    this.global._show_loader = true;

    this.service.getRequest(`Consumer/GetConsumer?ConsumerId=${consumerId}`)
      .subscribe({
        next: (response) => {
          this.global._show_loader = false;

          if (response.statusCode === '200' && response.data) {
            // Patch the form with the fetched data
            this.patchProfileForm(response.data);

            // Open the modal
            this.bsModalRef = this.modalService.show(this.editProfileModal, {
              class: 'modal-lg',
              backdrop: 'static',
              keyboard: false
            });
          } else {
            this.global.showNotification('Error', '', 'Failed to load profile data');
          }
        },
        error: (error) => {
          this.global._show_loader = false;
          console.error('Error fetching profile data:', error);
          this.global.showNotification('Error', '', 'Failed to load profile data');
        }
      });
  }


  passwordMatchValidator(g: FormGroup) {
    const password = g.get('passwordHash')?.value;
    const confirmPassword = g.get('confirmPassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      g.get('confirmPassword')?.setErrors({ 'passwordMismatch': true });
      return { 'passwordMismatch': true };
    }

    // Clear the error if passwords match or one field is empty
    if (g.get('confirmPassword')?.hasError('passwordMismatch')) {
      g.get('confirmPassword')?.setErrors(null);
    }
    return null;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  closeEditModal() {
    this.bsModalRef?.hide();
  };

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }


  updateProfile() {
    if (this.editProfileForm.invalid) {
      console.log('Form invalid:', this.editProfileForm.errors);
      Object.keys(this.editProfileForm.controls).forEach(key => {
        const control = this.editProfileForm.get(key);
        if (control.invalid) {
          console.log(`Field ${key} is invalid:`, control.errors);
        }
      });
      return;
    }

    const formValue = this.editProfileForm.getRawValue();

    const payload = {
      id: formValue.id,
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      email: formValue.email,
      phoneNumber: formValue.phoneNumber,
      countryId: formValue.country,
      stateId: formValue.stateId,
      cityName: formValue.cityName,
      zipcode: formValue.zipcode,
      address1: formValue.address1,
      address2: formValue.address2,
      defaultProId: formValue.defaultProId,
      isSelfCreated: formValue.isSelfCreated,
      createdBy: Number(formValue.createdBy) || 0,
      stepNo: Number(formValue.stepNo) || 0,
      fCMToken: formValue.fCMToken,
      gPSLocation: formValue.gPSLocation,
      passwordHash: formValue.passwordHash,

    };

    this.global._show_loader = true;

    // Use correct API endpoint from cURL
    this.service
      .postRequest('Consumer/UpdateConsumer', payload)
      .subscribe({
        next: (res) => {
          this.global._show_loader = false;
          if (res.statusCode === '201') {
            this.global.showNotification('Success', '', 'Profile updated successfully');
            this.closeEditModal();
          } else {
            this.global.showNotification('Error', '', 'Profile failed: ' + (res.message || 'Unknown error'));
          }
        },
        error: (error) => {
          this.global._show_loader = false;
          console.error('Update error:', error);
          this.global.showNotification('Error', '', 'Something went wrong: ' + (error.message || 'Unknown error'));
        }
      });
  }



  getStates(e) {
    this.getLatLongFromApi(e)
    this.consumerVar.countries.find((country: any) => {
      if (typeof (e) == "number") {
        if (e == country.id) {
          this.consumerVar.states = country.states;
        }
      }
      else {
        if (e.target.value.split(":")[1].trim() == country.id) {
          if (this.editProfileForm.get('countryId').value) {
            this.editProfileForm.controls['stateId'].setValue(null);
          }
          this.consumerVar.states = country.states;
          this.editProfileForm.controls['countryId'].setValue(country.id);
        }
      }
    })
  }

  getCountries() {
    this.service.getRequest("Country/GetAllCountries").subscribe(
      (response) => {
        this.consumerVar.countries = [];
        if (response.statusCode == "A-409") {
          this.global.showNotification("Error", "", `already exist.`);
        } else if (response.statusCode == "200") {
          response.data.map((country: any) => {
            let CountryObj = {
              id: country.id,
              code: country.code,
              name: country.name,
              states: country.states,
            }
            this.consumerVar.countries.push(CountryObj)
          });
        }
      },
      (error) => {
        this.global.showNotification("Error", "", "Something went wrong.");
        this.global._show_loader = false;
      }
    );
  }

  getProByID() {
    this.service
      .getRequest(`Customer/GetProByConsumerID?id=${this.global.getProObj().id}`).subscribe(
        (response) => {
          if (response.status == "200") {
            this.topNavVar.proId = response.proId;
            this.topNavVar.proName = response.proName;
            this.topNavVar.proPhoneNumer = response.phoneNumber;
          } else if (response.statusCode == "409") {

          } else {

          }
        },
        (error) => {
          this.global.showNotification('Error', '', 'Records do not exist');
          this.global._show_loader = false;
        }
      );
  }

  initWholesalerForm() {
    this.addWholesalerForm = this.formBuilder.group({
      id: [this.global.getProObj().id, Validators.compose([Validators.nullValidator])],
      wholesalerId: [0, Validators.compose([Validators.nullValidator])],
      proSearch: [null, Validators.compose([Validators.nullValidator])],
      name: [null, Validators.compose([Validators.required])],
      proId: [null]
    })
  }

  
  editWholesaler(name: any) {
    this.addWholesalerForm.reset()
    this.topNavVar.wholesalers.find((wholesaler: any) => {
      if (name == wholesaler.name) {

        console.log("wholesaler in top nav dashboard", wholesaler);
        this.addWholesalerForm.controls['wholesalerId'].setValue(wholesaler.id);
        this.addWholesalerForm.controls['name'].setValue(wholesaler.name);
      }
    })
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    } else {
      console.log('Geolocation is not available in this browser.');
    }
    this.openFormModal(this.addWholesalerModal);
  }
  checkWholesaler() {
    console.log("this.global.getProObj()", this.global.getProObj());

    this.topNavVar.proId = this.global.getProObj().defaultProId
    console.log("this. topNavVar.wholesalerId", this.topNavVar.proId);

    if (this.topNavVar.proId === null || this.topNavVar.proId === 0) {
      this.openFormModal(this.addWholesalerModal)
    }
    else {
      this.global.name = this.global.getProObj().wholesalerName
    }
  }
  submitAddWholesaler(obj: any) {
    console.log(obj);
    this.latitude;
    this.longitude;
    console.log('latitide', this.latitude);
    console.log('longitude', this.longitude);
    this.saveWholesaler(obj);
  }
  saveWholesaler(obj) {
    obj.proId;
    this.global._show_loader = true;
    this.service.getRequest(`Customer/UpdateProByConsumerID?consumerID=${this.global.getProObj().id}&proId=${obj.proId}`).subscribe(
      (response) => {
        if (response == 410) {

          this.global._show_loader = false;
        } else if (response == 200) {
          this.closeAddWholesalerModal();
          this.global.showNotification("Success", "", "Pro saved successfully.");
          this.global._show_loader = false;
          this.getProByID();
          // this.global.name = this.addWholesalerForm.value.name
          // localStorage.setItem("WHOLESALER", this.global.name);
          // let newObj = this.global.getProObj();
          // newObj.wholesalerId = this.addWholesalerForm.value.wholesalerId
          // newObj.wholesalerName = this.addWholesalerForm.value.name
          // localStorage.setItem(this.global.settings.PRO_OBJ, btoa(JSON.stringify(newObj)));
          // this.global._show_loader = false;
          // localStorage.setItem("AcknowledgeGuidelines", 'true')


        } else {
          this.global.showNotification("Error", "", "Something went wrong.");
          this.global._show_loader = false;
        }
      },
      (error) => {
        this.global.showNotification("Error", "", "Something went wrong.");

        this.global._show_loader = false;
      }
    );
  }


  getCurrentLocation(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('Geolocation not supported');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          resolve(`${lat},${lng}`);
        },
        (error) => reject(error.message),
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  }



  async GetPro() {
    debugger;

    let gpsLocation = '';

    if (
      this.proObj.gpsLocation === null ||
      this.proObj.gpsLocation === '0.0.0.0' ||
      this.proObj.gpsLocation === 'null,null'
    ) {
      try {
        gpsLocation = await this.getCurrentLocation();
      } catch (err) {
        console.error('GPS error', err);
        gpsLocation = '';
      }
    } else {
      gpsLocation = this.proObj.gpsLocation;
    }

    if (this.addWholesalerForm.value.proSearch) {
      var query = this.addWholesalerForm.value.proSearch;
      var latlong = this.latitude + "," + this.longitude;
      var distanse = 0;
      var object = {
        search: query,
        //ConsumerGPSLocation: latlong
        ConsumerGPSLocation: gpsLocation
      }
      this.getPros(object);
    }
    else if (this.addWholesalerForm.value.name) {
      this.addWholesalerForm.value.proSearch = null;
      var distanse = parseInt(this.addWholesalerForm.value.name);
      //var latlongcor = this.latitude + "," + this.longitude;

      var object2 = {
        search: this.addWholesalerForm.get('proSearch').value,
        //ConsumerGPSLocation: latlongcor,
        ConsumerGPSLocation: gpsLocation,
        miles: distanse
      }
      this.getPros(object2);

    }
  }
  openFormModal(wholesalerModal: TemplateRef<any>) {
    this.global.modalConfig.class = "modal-md modal-dialog-centered";
    this.wholesalerModalRef = this.modalService.show(
      wholesalerModal,
      this.global.modalConfig
    );
  }
  closeAddWholesalerModal() {
    this.wholesalerModalRef.hide()
    this.proList = []
  }
  getPros(obj) {
    if (obj.miles === undefined) {
      obj.miles = 0
    }
    //obj.miles ? 0 : obj.miles; 
    this.global._show_loader = true;
    this.service.getRequest(`DistanceProConsumer?search=${obj.search}&consumerGPSLocation=${obj.ConsumerGPSLocation}&miles=${obj.miles}`).subscribe(
      (response) => {
        this.proList = [];
        if (response.statusCode == "200" && response.data !== null) {
          this.proList = response.data;
          this.global._show_loader = false;
          //this.closeInstructionsModal();
        }
        else if (response.statusCode == "200") {
          this.global.showNotification("info", "", "Pro not found.");
          this.addWholesalerForm.reset();
          this.global._show_loader = false;
        }
        else {
          this.global.showNotification("Error", "", "Something went wrong.");
          this.global._show_loader = false;
        }
      },
      (error) => {
        this.global.showNotification("Error", "", "Something went wrong.");

        this.global._show_loader = false;
      }
    );
  }
  closeInstructionsModal() {
    this.instructionsModalRef.hide();
    localStorage.setItem("AcknowledgeGuidelines", 'true')
  }
  acknowledgeGuidelines() {
    this.global._show_loader = true;
    this.service.getRequest(`Pro/IsGuideAcknowledge?ProID=${this.global.getProObj().id}&IsGuideAck=${true}`).subscribe(
      (response) => {
        if (response.statusCode == "200") {

          this.global._show_loader = false;
          this.closeInstructionsModal();
        } else {
          this.global.showNotification("Error", "", "Something went wrong.");
          this.global._show_loader = false;
        }
      },
      (error) => {
        this.global.showNotification("Error", "", "Something went wrong.");

        this.global._show_loader = false;
      }
    );
  }

  fullScreenClick() {

    this.isFullScreen = !this.isFullScreen;
    if (this.isFullScreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }

  logoutuser() {
    var USERStr = localStorage.getItem(this.global.settings.PRO_OBJ)
    var obj = JSON.parse(atob(USERStr))
    var objid = this.proObj.loginId;

    this.service.postRequest(`UserLogin/Logout?loginID=1`, objid).subscribe(
      (response) => {
        localStorage.removeItem('userCredentials');
        localStorage.removeItem(this.global.settings.ETRAPP_USER);
        localStorage.removeItem("UserName");
        localStorage.removeItem("ID");
        localStorage.removeItem("logo");
        localStorage.removeItem("empID");
        localStorage.removeItem("OrgID");
        localStorage.removeItem("RoleID");
        localStorage.removeItem("uType");
        localStorage.removeItem("thankyouVar");
        this.router.navigate(['/login']);
      },
      (error) => {
        this.global.showNotification('Error', '', 'Something Went Wrong');
      }
    );


  }



  mobileMenuButtonClick = (event: { stopPropagation: () => void; }, containerClassnames: string) => {
    if (event) { event.stopPropagation(); }
    this.sidebarService.clickOnMobileMenu(containerClassnames);
  }

  menuButtonClick = (e: { stopPropagation: () => void; }, menuClickCount: number, containerClassnames: string) => {
    if (e) { e.stopPropagation(); }

    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);

    this.sidebarService.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.sidebar.selectedMenuHasSubItems
    );
  }

  getColor() {
    return localStorage.getItem(environment.themeColorStorageKey)
      ? localStorage.getItem(environment.themeColorStorageKey)
      : environment.defaultColor;
  }
  onDarkModeChange(event) {
    let color = this.getColor();
    if (color.indexOf('dark') > -1) {
      color = color.replace('dark', 'light');
    } else if (color.indexOf('light') > -1) {
      color = color.replace('light', 'dark');
    }
    localStorage.setItem(environment.themeColorStorageKey, color);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }



  getLatLongFromApi(e) {
    // // debugger
    if (this.editProfileForm.controls.address1.valid && this.editProfileForm.controls.cityName.valid && this.editProfileForm.controls.stateId.valid) {
      const requestData = {
        address: this.editProfileForm.controls.address1.value,
        city: this.editProfileForm.controls.cityName.value,
        state: this.consumerVar.states.find(state => state.id == this.editProfileForm.controls.stateId.value)
      };
      this.service.getRequest(`Location?stateName=${requestData.state.name}&cityName=${requestData.city}&address=${requestData.address}`)
        .subscribe((response) => {
          if (response.statusCode === 200) {
            this.currentLocationLatLng = response.locationSearch;
            let lat = this.currentLocationLatLng.latitude
            let long = this.currentLocationLatLng.longitude
            this.currentLocationLatLng = lat + ',' + long
            this.editProfileForm.controls['gpsLocation'].setValue(this.currentLocationLatLng)
          } else {
            this.global.showNotification('Error', '', 'The address you entered is not valid. Please try another one!')
            this.editProfileForm.controls['gpsLocation'].setValue(null)
          }
        }, (error) => {
          this.global.showNotification('Error', '', 'The address you entered is not valid. Please try another one!')
          this.editProfileForm.controls['gpsLocation'].setValue(null)
        });
    }
  }

  ValidateProEmail(obj) {
    this.service.getRequest(`Pro/ValidateProEmail?email=${obj}`).subscribe(
      (response) => {
        if (response.statusCode == "200") {
          this.consumerVar.apiResponse = true;
          this.editProfileForm.setErrors({ 'invalid': true });
        } else if (response.statusCode == "204") {
          this.consumerVar.apiResponse = false;
          this.editProfileForm.setErrors({ 'invalid': false });
        } else {
          this.consumerVar.apiResponse = false;
          this.editProfileForm.setErrors({ 'invalid': false });
        }
      },
      (error) => {
        console.log('Error', obj)
      }
    );
  }


  // Add these helper methods to your component:

  findCountryIdByCode(countryCode: string): number | null {
    const country = this.consumerVar.countries.find(c => c.code === countryCode);
    return country ? country.id : null;
  }

  findStateIdByCode(stateCode: string): number | null {
    const state = this.consumerVar.states.find(s => s.code === stateCode);
    return state ? state.id : null;
  }

}
